import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const mcpService = {
  async getActiveRun(projectId) {
    const res = await axios.get(`${API}/mcp/runs/active?project_id=${projectId}`);
    return res.data;
  },

  async cancelRun(runId) {
    const res = await axios.post(`${API}/mcp/runs/${runId}/cancel`);
    return res.data;
  },

  async forceStopRun(runId) {
    const res = await axios.post(`${API}/mcp/runs/${runId}/force-stop`);
    return res.data;
  },

  async getStatus() {
    const res = await axios.get(`${API}/mcp/status`);
    return res.data;
  },

  async listTokens() {
    const res = await axios.get(`${API}/mcp/tokens`);
    return res.data;
  },

  async createToken({ name, scopes, expiresInDays, clientHint }) {
    const res = await axios.post(`${API}/mcp/tokens`, {
      name,
      scopes,
      expires_in_days: expiresInDays || null,
      client_hint: clientHint || null,
    });
    return res.data;
  },

  async revokeToken(tokenId) {
    const res = await axios.delete(`${API}/mcp/tokens/${tokenId}`);
    return res.data;
  },

  async listScopes() {
    const res = await axios.get(`${API}/mcp/scopes`);
    return res.data;
  },

  async updateTokenScopes(tokenId, scopes) {
    const res = await axios.patch(`${API}/mcp/tokens/${tokenId}/scopes`, { scopes });
    return res.data;
  },

  async getLimits() {
    const res = await axios.get(`${API}/mcp/limits`);
    return res.data;
  },

  async requestLimitIncrease({ limitKey, value, reason }) {
    const res = await axios.post(`${API}/mcp/limits/requests`, {
      limit_key: limitKey,
      requested_value: value,
      reason: reason || null,
    });
    return res.data;
  },

  async listAudit(limit = 50) {
    const res = await axios.get(`${API}/mcp/audit?limit=${limit}`);
    return res.data;
  },
};

export default mcpService;
